import React from "react";

const renderWhyIcon = (iconName) => {
  if (iconName === "Shield") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 3l7 3v5c0 4.5-2.9 8.1-7 10-4.1-1.9-7-5.5-7-10V6l7-3z" />
        <path d="M9 12l2 2 4-4" />
      </svg>
    );
  }

  if (iconName === "R&D") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M8 6h8M8 18h8" />
        <path d="M9 6a3 3 0 000 6h6a3 3 0 010 6" />
        <circle cx="9" cy="12" r="1.5" />
        <circle cx="15" cy="18" r="1.5" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 12h5l2-3 4 6 2-3h3" />
      <path d="M6 18h12" />
      <path d="M12 6v12" />
    </svg>
  );
};

function Why({ content }) {
  return (
    <section className="why-section">
      <div className="section-wrap">
        <div className="section-eyebrow">{content?.eyebrow}</div>
        <h2 className="section-title why-title">{content?.title}</h2>
        <div className="why-grid">
          {(content?.reasons || []).map((reason) => (
            <div className="why-card" key={reason.num}>
              <div className="why-num">{reason.num}</div>
              <div className="why-icon-box" aria-hidden="true">
                {renderWhyIcon(reason.icon)}
              </div>
              <h4>{reason.title}</h4>
              <p>{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Why;
